import React, { useState } from 'react';
import propTypes from 'prop-types';
import Input from '../Input';

export default function CommentReplyForm({ onSubmit }) {
  const [reply, setReply] = useState('');
  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        onSubmit(reply);
      }}
      className="reply-form pt-3"
    >
      <div className="form-input d-flex flex-column">
        <small>Enviar resposta</small>
        <Input value={reply} onChange={e => setReply(e.target.value)} focus />
        <button type="submit" className="btn btn-primary mt-2 ">
          {' '}
          enviar
        </button>
      </div>
    </form>
  );
}

CommentReplyForm.propTypes = {
  onSubmit: propTypes.func.isRequired,
};
